<ng-container *hasPermission="['ORGANIZATIONS_READ','ORGANIZATIONS_ALL', 'SAFESTREET_ADMIN']">
    <div class="container-fluid">
        <div class="page-title">
            <h2>Elenco enti</h2>
        </div>
        <app-filter-panel [criteria]="searchCriteria">
            <ng-template #fields>
                <form [formGroup]="searchForm" (ngSubmit)="search()">
                    <div class="row">
                        <div class="mb-4">
                            <label for="name" class="form-label">Name</label>
                            <input type="text" class="form-control" id="name" name="name" formControlName="name" />
                        </div>
                    </div>

                    <div class="d-flex justify-content-end  align-items-center col-12 m-2 gap-2">
                        <button type="button" class="btn  btn-outline-secondary"
                            (click)="clearFilter()">Cancella</button>
                        <button type="submit" class="btn btn-primary"  >Cerca</button>
                    </div>
                </form>
            </ng-template>
        </app-filter-panel>
        <div class="section-container">
            <div class="table-responsive">
                <table class="table caption-top table-hover table-striped">
                    <caption>
                        <button type="button" class="btn btn-primary" (click)="edit(0)"
                            *hasPermission="['ORGANIZATIONS_CREATE','ORGANIZATIONS_ALL', 'SAFESTREET_ADMIN']"><i
                                bTooltip title="Aggiungi" class="fa-solid fa-plus"></i></button>


                        Risultati trovati: {{totalItems}}
                    </caption>
                    <thead>
                        <tr>
                            <th scope="col" class="row-button-sm"></th>
                            <th scope="col">#</th>
                            <th scope="col" class="cursor-pointer" app-th-ordering [colName]="'name'"
                                [colValue]="'Nome'" [baseSearchCriteria]="searchCriteria"
                                (orderingClick)="ordering($event)"></th>
                            <th scope="col" class="cursor-pointer" app-th-ordering [colName]="'cityName'"
                                [colValue]="'Comune'" [baseSearchCriteria]="searchCriteria"
                                (orderingClick)="ordering($event)"></th>
                            <th scope="col" class="cursor-pointer" app-th-ordering [colName]="'licenseName'"
                                [colValue]="'Licenza'" [baseSearchCriteria]="searchCriteria"
                                (orderingClick)="ordering($event)"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let organization of organizations | paginate: {
                        itemsPerPage: searchCriteria.pageSize,
                        currentPage: searchCriteria.pageNumber,
                        totalItems: totalItems } ">
                            <td>
                                <div class="d-flex justify-content-center  align-items-center gap-2">
                                    <div class="cursor-pointer" (click)="edit(organization.id!)"
                                        *hasPermission="['ORGANIZATIONS_UPDATE','ORGANIZATIONS_ALL', 'SAFESTREET_ADMIN']">
                                        <i bTooltip title="Modifica" class="fa-solid fa-pen"></i>
                                    </div>
                                    <div class="cursor-pointer" (click)="confirmOperation(organization,'DEL')"
                                        *hasPermission="['ORGANIZATIONS_DELETE','ORGANIZATIONS_ALL', 'SAFESTREET_ADMIN']">
                                        <i bTooltip title="Elimina" class="fa-solid fa-trash"></i>
                                    </div>

                                </div>
                            </td>
                            <th scope="row">{{organization.id}}</th>
                            <td>{{organization.name}}</td>
                            <td>{{organization.cityName}}</td>
                            <td>{{organization.licenseName}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <pagination-controls (pageChange)="pageChanged($event)" (pageBoundsCorrection)="pageChanged($event)"
                previousLabel="Precedente" nextLabel="Successiva" screenReaderPaginationLabel="Paginazione"
                screenReaderPageLabel="Pagina" screenReaderCurrentLabel="Vai alla pagina">
            </pagination-controls>
        </div>
    </div>
    <app-confirm-alert [confirmationMessage]="confirmationMessage" [showConfirmationModal]="showConfirmationModal"
        (modalConfirm)="modalOperationExec()" (modalCancel)="cancelModalOperationExec()">
    </app-confirm-alert>
</ng-container>